"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var JurisdictionButton_1 = require("../../../AddDebtWizard/addDebt/JurisdictionPicker/JurisdictionButton");
var EditDebtJurisidction = function (props) {
    return (React.createElement("div", { className: "protocol-tile-container protocol-tile-jurisdiction ".concat(props.disabled ? 'protocol-tile-container-disabled' : '') },
        React.createElement("h3", { className: "protocol-tile-jurisdiction-header" }, "Jurisdiction:"),
        React.createElement("div", { className: "protocol-tile-jurisdiction-buttons" },
            React.createElement(JurisdictionButton_1.default, { setFieldValue: props.setFieldValue, text: 'England and Wales', jurisdiction: 'england_wales', value: props.values.jurisdiction }),
            React.createElement(JurisdictionButton_1.default, { setFieldValue: props.setFieldValue, text: 'Scotland', jurisdiction: 'scotland', value: props.values.jurisdiction }))));
};
exports.default = EditDebtJurisidction;
